const moment = require('@transfeeradev/moment');

class DateService {
  static replaceDateInDateTime(newDate, dateTime) {
    newDate = moment(newDate);
    dateTime = moment(dateTime);

    return dateTime
      .set({
        year: newDate.year(),
        month: newDate.month(),
        date: newDate.date()
      })
      .format();
  }

  static getFormatted(date) {
    if (date && typeof date === 'string') {
      if (moment(date, 'DD/MM/YYYY').isValid()) {
        return moment(date, 'DD/MM/YYYY').format();
      }

      if (moment(date, 'YYYY-MM-DD').isValid()) {
        return moment(date).format();
      }

      return null;
    }

    return date;
  }

  static getPrevBusinessDay(days = 1) {
    let date;

    do {
      date = moment(date).subtract(1, 'day');

      if (date.isBusinessDay()) {
        days--;
      }
    } while (days);

    return date;
  }

  static getNextBusinessDay(days = 1) {
    let date;

    if (days === 0) {
      if (moment().isBusinessDay()) {
        return moment();
      }

      days = 1;
    }

    do {
      date = moment(date).add(1, 'day');

      if (date.isBusinessDay()) {
        days--;
      }
    } while (days);

    return date;
  }

  static period(startsAt, endsAt, period) {
    return {
      start: moment(startsAt).startOf(period).format(),
      end: moment(endsAt).endOf(period).format()
    };
  }
}

module.exports = DateService;
